import axios from 'axios';
import store from '@/store/'

// Gemini AI 相關的 api
const geminiAI = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN+'/admin'
});

//請求攔截器
geminiAI.interceptors.request.use(
  config => {
    let token = store.getters.getAccessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//回應攔截器
geminiAI.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

// Gemini AI 時段助手 API
export function apiGeminiScheduleAssistant(data) {
  return geminiAI({
    url: '/gemini/schedule-assistant',
    method: 'post',
    data: data
  });
}